import Vue from 'vue'
import App from './App.vue'
import lodash from 'lodash'
import axios from 'axios'
import router from './router.js'
import { BootstrapVue, IconsPlugin, ToastPlugin } from 'bootstrap-vue'
import './theme.scss'
import VueI18n from 'vue-i18n'
import it from './i18n/it'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(ToastPlugin)

Vue.config.productionTip = false

Vue.prototype._ = window._ = lodash
const api_url = Vue.prototype.$api_url = (location.hostname == "localhost" ? "localhost:2001" : location.hostname)
Vue.prototype.$http = axios.create({
  baseURL: '//'+api_url+'/api/',
  // timeout: 30000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$url = path => {
  return '//'+api_url+path
}
import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

Vue.prototype.$utc = str => {
  if (!str || typeof str != 'string') return new Date()
  let pieces = str.match(/\d+/g)
  // console.log(pieces)
  return new Date(Date.UTC(Number(pieces[0]), Number(pieces[1])-1, Number(pieces[2]),
      Number(pieces[3]), Number(pieces[4]), Number(pieces[5])))
}

Vue.use(VueI18n)
let i18n = new VueI18n({
  locale: 'it',
  messages: { it },
  dateTimeFormats: {
    it: {
      short: {
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: {
        year: 'numeric', month: 'short', day: 'numeric',
        weekday: 'short', hour: 'numeric', minute: 'numeric'
      }
    },
  }
})


Vue.prototype.$pickFile = function(on_ok, on_cancel, accept) {
  var input = document.createElement('input')
  input.setAttribute('type', 'file')
  input.setAttribute('accept', accept)
  input.click()
  input.onchange = e => {
    var f = e.target.files[0]
    if (!f) {
      on_cancel && on_cancel()
    } else {
      on_ok && on_ok(f)
    }
  }
}

Vue.prototype.$toForm = function(data, name, fd, mandatory) {
  fd = fd || new FormData()
  name = name || ''
  if (data && typeof data === 'object' && data.constructor.name != 'File') {
    let is_array = data.constructor.name == 'Array'
    if (Object.values(data).length == 0) {
      this.$toForm('', name, fd)
    } else {
      for (var index in data) {
        var value = data[index]
        if (name == '') {
          this.$toForm(value, index, fd, is_array)
        } else {
          this.$toForm(value, name + '[' + index + ']', fd, is_array)
        }
      }
    }
  } else if (typeof data == 'boolean') {
    fd.append(name, data ? 1 : '')
  } else if (data !== null && data !== undefined && typeof data != 'function') {
    fd.append(name, data)
  } else if (mandatory) {
    fd.append(name, '')
  }
  return fd
}

import VueTimeago from 'vue-timeago'
Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  locales: { }
})

import VueSweetalert2 from 'vue-sweetalert2'
Vue.use(VueSweetalert2)

import CoolLightBox from "vue-cool-lightbox"
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
Vue.use(CoolLightBox)

new Vue({
  router,
  render: h => h(App),
  i18n,
}).$mount('#app')
